import React, { lazy } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
const Login = lazy(() => import('./pages/login/Login'))
const Password = lazy(() => import('./pages/password/Password'))
const ForgotPassword = lazy(() => import('./pages/forgot-password/ForgotPassWord'))
const ForgotUsername = lazy(() => import('./pages/forgot-username/ForgotUsername'))
const UpdatePassword = lazy(() => import('./pages/update-password/UpdatePassword'))
const Expired = lazy(() => import('./pages/expired/Expired'))
const TwoFactorSetup = lazy(() => import('./pages/two-factor-setup/TwoFactorSetup'))
const VerifyOtp = lazy(() => import('./pages/verify-otp/VerifyOtp'))
const AccountLinking = lazy(() => import('./pages/account-linking/AccountLinking'))
const UserLinking = lazy(() => import('./pages/user-linking/UserLinking'))
const AccountCreate = lazy(() => import('pages/account-create/AccountCreate'))
const JoinAccount = lazy(() => import('pages/join-account/JoinAccount'))
const Logout = lazy(() => import ('pages/logout/Logout'))
const CacLogout = lazy(() => import('pages/cac-logout/CacLogout'))
const LoginSuccess = lazy(() => import('pages/login-success/LoginSuccess'))
import {
  accountCreate,
  accountLinking,
  cacLogout,
  loginSuccess,
  expired,
  forgotPassWord,
  forgotUserName,
  joinAccount,
  login,
  logout,
  password,
  twoFactorSetup,
  updatePassWord, userLinking,
  verifyOtp
} from './utils/routes'

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path={login} component={Login} />
        <Route path={logout} component={Logout} />
        <Route path={cacLogout} component={CacLogout} />
        <Route path={password} component={Password} />
        <Route path={forgotPassWord} component={ForgotPassword} />
        <Route path={forgotUserName} component={ForgotUsername}/>
        <Route path={updatePassWord} component={UpdatePassword} />
        <Route path={expired} component={Expired} />
        <Route path={twoFactorSetup} component={TwoFactorSetup} />
        <Route path={verifyOtp} component={VerifyOtp} />
        <Route path={accountLinking} component={AccountLinking} />
        <Route path={userLinking} component={UserLinking} />
        <Route path={accountCreate} component={AccountCreate} />
        <Route path={joinAccount} component={JoinAccount} />
        <Route path={loginSuccess} component={LoginSuccess} />
      </Switch>
    </BrowserRouter>
  )
}

export default AppRouter;